'use client'

import PropTypes from 'prop-types'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import MUIStack from '@mui/material/Stack'
import MUIOutlinedInput from '@mui/material/OutlinedInput'
import MUITypography from '@mui/material/Typography'
import MUIIconButton from '@mui/material/IconButton'
import MUIInputAdornment from '@mui/material/InputAdornment'
import MUITooltip from '@mui/material/Tooltip'
import { FeeEarnerFilter } from '@repo/dashboard/FeeEarnerFilter'
import { useKpiStore } from '@repo/store/useKpiStore'
import { RefreshIcon } from '@repo/ui/RefreshIcon'
import { useState } from 'react'

const Label = ({ label }) => {
  return (
    <MUITypography
      variant="body2"
      aria-label={label}
      sx={{
        textTransform: 'uppercase',
        position: 'absolute',
        top: '-6px',
        left: '10px',
        backgroundColor: 'white',
        padding: '0px 4px',
        zIndex: 2,
        fontSize: '0.6875rem',
        color: 'text.secondary'
      }}
    >
      {label}
    </MUITypography>
  )
}

export const DashboardChartSettingsForm = ({ target, targetIsDefault }) => {
  const { selectedKpiId, setKpiTarget, feeEarnerIds, setFeeEarnerIds, kpiOptions } = useKpiStore()
  const [refreshButtonRotation, setRefreshButtonRotation] = useState(0)
  const refreshButtonRotationDuration = 1500
  const { feeEarnerId } = useAuthenticationStore()

  const handleResetTarget = () => {
    const kpi = kpiOptions.find((opt) => opt.kpiId === selectedKpiId)
    setKpiTarget({ kpiId: selectedKpiId, target: kpi.target })
    setRefreshButtonRotation(refreshButtonRotation - 359)
  }

  const getFeeEarnerIdsValue = () => {
    if (feeEarnerIds) return feeEarnerIds
    if (feeEarnerId) return [feeEarnerId]
    return []
  }

  if (!kpiOptions?.length) return <div data-testid="DashboardChartSettingsForm" />

  return (
    <MUIStack direction="row" gap={2} data-testid="DashboardChartSettingsForm">
      <div style={{ position: 'relative' }}>
        <Label label="Fee earners" />
        <FeeEarnerFilter
          value={getFeeEarnerIdsValue()}
          onChange={(value) => setFeeEarnerIds(value)}
          width="180px"
          sx={{ borderRadius: '17px', height: '34px' }}
        />
      </div>

      <div style={{ position: 'relative' }}>
        <Label label={`Target (${targetIsDefault ? 'Default' : 'Custom'})`} />
        <MUIOutlinedInput
          id="targetInput"
          aria-label="Target"
          label="target"
          value={target}
          type="number"
          onChange={(e) => setKpiTarget({ kpiId: selectedKpiId, target: e.target.value })}
          fullWidth
          sx={{ borderRadius: '17px', height: '34px', mb: 0, width: '160px', pr: '0' }}
          endAdornment={
            <MUIInputAdornment position="end">
              <MUITooltip title="Reset to default" placement="top" arrow>
                <MUIIconButton aria-label="Reset to default" onClick={handleResetTarget}>
                  <RefreshIcon
                    sx={{
                      transition: `transform ${refreshButtonRotationDuration}ms`,
                      transform: `rotate(${refreshButtonRotation}deg)`,
                      width: '18px',
                      height: '18px'
                    }}
                  />
                </MUIIconButton>
              </MUITooltip>
            </MUIInputAdornment>
          }
        />
      </div>
    </MUIStack>
  )
}

DashboardChartSettingsForm.propTypes = {
  target: PropTypes.any,
  targetIsDefault: PropTypes.bool
}

Label.propTypes = {
  label: PropTypes.string
}
